<template>
	<TransitionRoot
		as="template"
		:show="open">
		<Dialog
			as="div"
			class="relative z-40"
			:initial-focus="initialFocus"
			@close="() => {open = false; closeModal()}">
			<TransitionChild
				as="template"
				enter="ease-out duration-300"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="ease-in duration-200"
				leave-from="opacity-100"
				leave-to="opacity-0">
				<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
			</TransitionChild>
  
			<div class="fixed inset-0 z-50 w-screen overflow-y-auto">
				<div class="flex min-h-full items-end justify-center text-center sm:items-center sm:p-8">
					<TransitionChild
						as="template"
						enter="ease-out duration-300"
						enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enter-to="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leave-from="opacity-100 translate-y-0 sm:scale-100"
						leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
						<DialogPanel :class="[modalMaxWidth,'relative transform overflow-x-hidden overflow-y-auto rounded-lg bg-white h-200 pb-4 text-left shadow-xl transition-all sm:my-8 w-full sm:pb-4']">
							<div class="flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-5 sm:px-6 bg-white relative overflow-hidden border-b border-gray-200">
								<div>
									<DialogTitle>
										<h2 class="card-heading">
											{{ title }}
										</h2>
									</DialogTitle>
								</div>
								<div class="flex-shrink-0">
									<XMarkIcon 
										class="h-5 w-5 text-gray-700 hover:text-brand-500 cursor-pointer"
										@click="() => {open = false; closeModal()}" />
								</div>
								<card-header-backdrop class="opacity-20" />
							</div>
							<div
								id="modal-content"
								class="px-4 sm:px-6">
								<slot />
							</div>
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

  <script lang="ts">
  // name the component
	export default { name: 'TwModal' }
  </script>

  <script lang="ts" setup>
	import {
		defineExpose,
		PropType,
		ref
	} from 'vue'
	import {
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'
	import {
		XMarkIcon
	} from '@heroicons/vue/24/outline'

	/*eslint-disable*/
	const props = defineProps({
		description: {
			type: String,
			default: ""
		},
		modalMaxWidth: {
			type: String,
			default: 'max-w-screen-xl'
		},
		title: {
			type: String,
			default: ""
		},
		closeModal:{
			type: Function,
			default: () => {return}
		},
		initialFocus: {
			type: Object as PropType<HTMLElement | null>,
			default: null
		}
	})
  
	const open = ref(false)

	defineExpose({
		open
	})
  </script>

<style>
	#modal-content #tabs-select{
		@apply sticky top-0 left-0;
	}
	#modal-content div{
		@apply  relative;
	}
</style>